import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-health-sector-cmb.component.scss';
var FormItemHealthSectorCmb = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemHealthSectorCmb, _super);
    function FormItemHealthSectorCmb(element) {
        return _super.call(this, element) || this;
    }
    FormItemHealthSectorCmb.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-health-sector-cmb__button');
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
    };
    FormItemHealthSectorCmb.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
        }, false);
    };
    FormItemHealthSectorCmb.prototype.submitForm = function (pForm) {
        var _this = this;
        var _email = this.form.querySelector("input[name=email]");
        var _recipient = this.form.querySelector("input[name=recipient]");
        var _subject = this.form.querySelector("input[name=subject]");
        var _description = this.form.querySelector("input[name=description]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _lastName = this.form.querySelector("input[name=last-name]");
        var _contact = this.form.querySelector("input[name=contact-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _location = this.form.querySelector("select[name=location]");
        var _popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var _date = this.form.querySelector("input[name=date]");
        var _time = this.form.querySelector("select[name=time]");
        var _dateTime = "Anytime";
        if (_date && _time) {
            if (_time.value !== "Anytime") {
                _dateTime = _date.value + " " + _time.value;
            }
        }
        var _postData = {
            'email': (_email ? _email.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'description': (_description ? _description.value : ""),
            'firstName': (_firstname ? _firstname.value : ""),
            'lastName': (_lastName ? _lastName.value : ""),
            'contactNumber': (_contact ? _contact.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'location': (_location ? _location.value : ""),
            'popiConsent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO")),
            'bestTimeToCall': _dateTime
        };
        this.showDisplayView("loader");
        // variables
        var url = this.baseUrl + "/sites/services/HealthCareForm.jsp";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData), _config).then(function (pResponse) {
            _this.analyticsService.dtmFormComplete("complete", pResponse.code);
            _this.showDisplayView("success");
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemHealthSectorCmb.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemHealthSectorCmb;
}(Base));
export { FormItemHealthSectorCmb };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-health-sector-cmb/form-item-health-sector-cmb.component.ts
// module id = 915
// module chunks = 0